var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#0174C3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8984 19.8125V21H12.4531V19.9609L16.1797 15.8125C16.638 15.3021 16.9922 14.8698 17.2422 14.5156C17.4974 14.1562 17.6745 13.8359 17.7734 13.5547C17.8776 13.2682 17.9297 12.9766 17.9297 12.6797C17.9297 12.3047 17.8516 11.9661 17.6953 11.6641C17.5443 11.3568 17.3203 11.112 17.0234 10.9297C16.7266 10.7474 16.3672 10.6562 15.9453 10.6562C15.4401 10.6562 15.0182 10.7552 14.6797 10.9531C14.3464 11.1458 14.0964 11.4167 13.9297 11.7656C13.763 12.1146 13.6797 12.5156 13.6797 12.9688H12.2344C12.2344 12.3281 12.375 11.7422 12.6562 11.2109C12.9375 10.6797 13.3542 10.2578 13.9062 9.94531C14.4583 9.6276 15.138 9.46875 15.9453 9.46875C16.6641 9.46875 17.2786 9.59635 17.7891 9.85156C18.2995 10.1016 18.6901 10.4557 18.9609 10.9141C19.237 11.3672 19.375 11.8984 19.375 12.5078C19.375 12.8411 19.3177 13.1797 19.2031 13.5234C19.0938 13.862 18.9401 14.2005 18.7422 14.5391C18.5495 14.8776 18.3229 15.2109 18.0625 15.5391C17.8073 15.8672 17.5339 16.1901 17.2422 16.5078L14.1953 19.8125H19.8984Z",
    fill: "#353535"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2);
export default __webpack_public_path__ + "static/media/step-2.eb46d74b.svg";
export { ForwardRef as ReactComponent };